<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [separator]="false">
      <img image src="assets/warning-icon.png" [width]="44" [height]="38" />
    </email-message-header>
  </ng-container>

  <ng-container body>
    <email-margin [height]="28" />
    <email-text [contents]="data.p1_header" [bold]="true" />
    <br />
    <email-text [contents]="data.p1" />
    <email-margin [height]="28" />
    <email-text [contents]="data.p2_header" [bold]="true" />
    <br />
    <ol>
      <li><email-text [contents]="data.p2_1_html" /></li>
      <li><email-text [contents]="data.p2_2_html" /></li>
      <li><email-text [contents]="data.p2_3_html" /></li>
    </ol>
    <email-margin [height]="28" />
    <hr />
    <email-margin [height]="28" />
    <email-text
      [contents]="data.sent_to_all_admins"
      color="light"
      presetName="inline"
      size="small"
    />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
